import React from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import PrintDocument from "../../../../../../../popups/printPopup/printDocument";
import DesignNavigationItem from "../../../../../../../visComponents/designNavigationItem";
import {getFeatureGroupName} from "../../../../../../../../misc/helpers";
import {setSQFTContextMenu} from "../../../../../../../../actions/sqftMenuFunctions";
const CONTEXTMENU_HEIGHT = 350;
const CONTEXTMENU_WIDTH = 340;

const ContextmenuList = (props) => {
  const {handleItemClick, pos, contextMenuTitle, contextMenuSelection, contextMenuButtons, intl, fabricatorData,
    isMobile, windowHeight} = props;
  const {setSQFTContextMenu} = props;

  const getContextMenuPosition = (pos) => {
    if (CONTEXTMENU_HEIGHT + pos.y > windowHeight) {
      const offset = isMobile ? 20 : 70;
      pos.y = windowHeight - CONTEXTMENU_HEIGHT - offset;
    }
    return {
      left: pos.x + "px",
      top: pos.y + "px"
    };
  };

  // if (contextMenuButtons) {
  //   debugger // eslint-disable-line no-debugger
  // }
  const closeContextMenu = () => {
    setSQFTContextMenu({isOpened: false});
  }

  return(
    <div id="contextmenu"
         className="contextmenu contextmenu--sqft contextmenu-list "
         style={{...getContextMenuPosition(pos), width: CONTEXTMENU_WIDTH + "px", height: CONTEXTMENU_HEIGHT + "px"}}>
      <div className="contextmenu-list__title">
        {contextMenuTitle}
        <button className="ui-close contract-popup__close" onClick={closeContextMenu}/>
      </div>
      <div>
        { contextMenuSelection ? contextMenuSelection : null }
      </div>
      <div className="contextmenu-list__container">
        <ul className="contextmenu-list__list">
          {
            contextMenuButtons.map((menuItem, index) => {
              const name = menuItem.labelName || getFeatureGroupName(menuItem.part, intl, fabricatorData);
              return (
                <li key={index} className="contextmenu-list__item" >
                  <button
                    data-part-id = "menuItem.partId"
                    data-text = "  menuItem.text  "
                    className = {"contextmenu-list__button"}
                    onClick={(e) => handleItemClick(e, menuItem)}
                  >
                    <span className="contextmenu-list__button-text">
                      {name}
                    </span>
                  </button>
                </li>
              );
            })
          }
        </ul>
      </div>
    </div>
  );
};

PrintDocument.propTypes = {
  handleItemClick: PropTypes.func.isRequired,
  pos: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  contextMenuTitle: PropTypes.oneOf([PropTypes.object, PropTypes.string]),
  contextMenuSelection: PropTypes.object,
  contextMenuButtons: PropTypes.arrayOf(PropTypes.instanceOf(DesignNavigationItem)),
};


const mapStateToProps = (store) => ({
  fabricatorData: store.fabricatorState,
  isMobile: store.serverState.isMobile,
  windowHeight: store.serverState.windowHeight,
});

const mapDispatchToProps = {
  setSQFTContextMenu
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ContextmenuList)
);

